export default "__VITE_ASSET__DRRwutuS__"